import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT } from '@pinnakl/core/environment';
import { API_URLS } from '@pinnakl/core/web-services';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';

export class OutlookSessionExpiredError extends HttpErrorResponse {}

export const outlookAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const apiUrls = inject(API_URLS);
  const userService = inject(UserService);
  const environment = inject(ENVIRONMENT);
  const requestOrigin = new URL(req.url, window.location.href).origin;
  const isApiRequest = [environment.coreApiServerUrl, environment.authApiServerUrl, environment.fileServiceUrl].some(
    url => url && new URL(url).origin === requestOrigin,
  );
  if (!isApiRequest) return next(req);
  if (req.url === apiUrls.auth && req.method === 'POST') return next(req);

  const token = userService.getToken();
  const response = token
    ? next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }))
    : throwError(() => new HttpErrorResponse({ status: 401, statusText: 'Session expired', url: req.url }));

  return response.pipe(
    catchError((error: unknown) => {
      const currentToken = userService.getToken();
      if (!(error instanceof HttpErrorResponse) || error.status !== 401 || (currentToken && currentToken !== token))
        return throwError(() => error);

      if (currentToken === token) {
        userService.clearUser().subscribe({ error: () => {} });
        router.navigate(['/login'], { skipLocationChange: true });
      }
      return throwError(() => new OutlookSessionExpiredError({ ...error, url: error.url ?? undefined }));
    }),
  );
};
